const shopifyLoader = ({ src, width }) => {
    const baseUrl = new URL(src)
    const newUrl = new URL(
        baseUrl.pathname,
        'https://balticwatches-6242.imgix.net'
    )

    newUrl.searchParams.set('auto', 'format,compress')
    newUrl.searchParams.set('w', width)

    return newUrl.href
}

export default function ShopifyImage({ src, width = 400, ...props }) {
    const imgSrc = shopifyLoader({ src, width })
    return <img src={imgSrc} loading="lazy" {...props} alt="" />
}
